module.exports = __webpack_public_path__ + "img/alarm.5a40a79b.svg";